// Convert em based breakpoints into pixel breakpoint for consumption by older plugins
function breakpointConverter(breakpoint) {
  let processedBreakpoint = breakpoint.replace(/^em/i, '');
  return parseInt(processedBreakpoint) * 16;
}

export default breakpointConverter;
